import { useTranslation } from 'react-i18next'

import * as Styles from './styles.js'

const CustomerDetailInfo = ({ customerProfile, nameLabel = 'Nombre cliente', address }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Styles.Info>
        <label>{t(nameLabel)}</label>
        <p>
          {customerProfile?.first_name} {customerProfile?.last_name}
        </p>
      </Styles.Info>
      <Styles.Info>
        <label>{t('Email')}</label>
        <p>{customerProfile?.email || '-'}</p>
      </Styles.Info>
      <Styles.Info>
        <label>{t('Teléfono')}</label>
        <p>{customerProfile?.phone ? `+${customerProfile?.phone?.prefix} ${customerProfile?.phone?.number}` : '-'}</p>
      </Styles.Info>
      {address && (
        <Styles.Info>
          <label>{t('Dirección')}</label>
          <p>
            {address?.line_1} {address?.line_2} {address?.house_number}
          </p>
          <p>
            {address?.postcode} {address?.locality} {address?.province?.name}
          </p>
          <p>{address?.country?.name}</p>
        </Styles.Info>
      )}
    </Styles.Container>
  )
}

export default CustomerDetailInfo
